import React, { useState, useEffect } from "react"

import { Form } from "react-bootstrap"

import InputField from './elements/input'
import SelectField from './elements/select'
import TextAreaField from './elements/textarea'
import CheckboxField from './elements/checkbox'
import RadioField from './elements/radio'
import ButtonField from './elements/button'
import HtmlBox from './elements/html'
import ReCaptchaBox from './elements/recaptcha'
import { postFormData } from "./api/Api"
import InstantValuationSteps from "./instant-valuation-steps"
import axios from "axios"
import * as qs from "query-string"
import _ from "lodash";import $ from "jquery"


function MySimpleForm(props) {
  const [startDate, setStartDate] = useState();
  const [startTime, setStartTime] = useState();
  const [validated, setValidated] = useState(false);
  const [showerror, setShowerror] = useState(false);
  const [showthankyou, setThankyou] = useState(false);
  const [radioval, setRadioval] = useState('sale');
  const [formvalues, setFormvalues] = useState("");

  const [token, setToken] = useState("");

  const myRef = React.createRef();

  const recaptchaRef = React.createRef();

  const fields = ([
      {
        element: "config",
        formname: "Instant Valuation",
        form_type: "contact",
        error_text: "Highlighted fields are required",
        success_text: "Thank you for contacting us. A member of our team will contact you shortly.",
        email_temp_user: "instant_valuation_user",
        email_temp_admin: "instant_valuation_admin",
        email_subject_user:"Instant Valuation",
        email_subject_admin:"Instant Valuation",
        email_server_func: "instant_valuation",
        event_tracking: "contact",
        page_url: "/general-enquiry"
      },  
      {
        grpmd: "12",
        placeholder: "Sale",
        name: "enquirytype",
        type: "text",
        label: "For Sale",
        value:"sales",
        element: "radio",
        required: true,
        fieldClass: "",
        labelClass: "content_b-18"
      },
      {
        grpmd: "12",
        label: "To Let",
        placeholder: "Rental",
        name: "enquirytype",
        type: "text",
        value:"lettings",
        element: "radio",
        required: true,
        fieldClass: "",
        labelClass: "content_b-18"
      },
      {
        grpmd: "12",
        label: "Both",
        placeholder: "Both",
        name: "enquirytype",
        type: "text",
        value:"both",
        element: "radio",
        checked: "checked",
        required: true,
        fieldClass: "",
        labelClass: "content_b-18"
      }, 
      {
        grpmd: "12",
        label: "",
        placeholder: "Start typing your address...",
        name: "address",
        type: "text",
        element: "input",
        required: true,
        patternchk: "^[-a-zA-Z0-9-()]+(\\s+[-a-zA-Z0-9-()]+)*$",
        labelClass: "content_b-18"
      },    
      {
        grpmd: "12",
        label: "",
        placeholder: "Your Name",
        name: "name",
        type: "text",
        element: "input",
        required: true,
        patternchk: "^[-a-zA-Z0-9-()]+(\\s+[-a-zA-Z0-9-()]+)*$",
        labelClass: "content_b-18"
      },
      {
        grpmd: "12",
        label: "",
        placeholder: "Your Email",
        name: "email",
        type: "email",
        element: "input",
        required: true,
        patternchk:"[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,}$",
        labelClass: "content_b-18"

      },
      {
        grpmd: "12",
        label: "",
        placeholder: "Your phone number",
        name: "telephone",
        type: "text",
        element: "input",
        required: true,
        patternchk:"^[+]*[0-9-()]+(\\s+[0-9-()]+)*.{9}$",
        labelClass: "content_b-18"

      },   
      {
        grpmd: "12",
        label: "",
        placeholder: "Preferred date",
        name: "date",
        type: "datetime",
        element: "input",
        // min: today,
        // max: maxday.toString(),
        required: true,
        patternchk: "",
        class: "mb-4 form-control date"
      },    
      {
        grpmd: "12",
        label: "",
        placeholder: "Enter your postcode",
        name: "postcode",
        type: "text",
        element: "input",
        required: true,
        patternchk: "^[-a-zA-Z0-9-()]+(\\s+[-a-zA-Z0-9-()]+)*$",
        labelClass: "content_b-18"
      },
      {
        grpmd: "12",
        label: "",
        placeholder: "Your message",
        name: "message",
        element: "textarea",
        class: "mb-4 area",
        rows:"3",
        labelClass: "content_b-18"
      },  
    
      {
        grpmd: "12",
        name: "Submit",
        type:"submit",
        element: "button",
        value: "submit",
        class: "w-md-100 mtop-btn  btn btn-primary",
        labelClass: "content_b-18"
      },
      
      {
        element: "captcha",
        class: "py-2",
        captchaRef: recaptchaRef
      },
    ]);

  const handlechange = event => {
    // remove initial empty spaces
    event.target.value = event.target.value.trimStart()
  }
  const getRadio = event => {
    event.target.value = event.target.value.trimStart()  
    setRadioval(event.target.value)
  }

  useEffect(() => {
    $('#enquirytypesale').attr('checked',true)
    if (token !== '') {

 const processFromData = async () => {
      
      formvalues['g-recaptcha-response'] = token;
      
      let formData = new FormData();

      // formvalues['extra'] = JSON.stringify({
      //   message: formvalues.message,
      //   name: formvalues.name
      // });
      formvalues['name'] = formvalues.name;
      formvalues['email_subject_user'] = fields[0].email_subject_user;
      formvalues['email_subject_admin'] = fields[0].email_subject_admin;

      formData.append('data', JSON.stringify(formvalues));

      postFormData(formData).then(async apiRes => {
      
      //window.grecaptcha.reset()

      // lets send mail
      await window.fetch(`${process.env.GATSBY_CLOUD_URL}/api/form`, {
        method: `POST`,
        mode: "no-cors",
        headers: {
          'Access-Control-Allow-Origin': '*',
          "Content-Type": "application/x-www-form-urlencoded",
        },
        body: qs.stringify(formvalues),
      })

      });

    
      // tracking event
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        'event': 'formSubmit',
        'formType': 'form-'+fields[0].event_tracking,
        'formId': 'form-'+fields[0].event_tracking,
        'formName': fields[0].formname,
        'formLabel': formvalues.enquirytype+' - '+fields[0].formname
      });

      setShowerror(false);
      setThankyou(true);
      
      myRef.current.scrollIntoView({ behavior: 'smooth', block: 'center' })

      }
      processFromData();

    }
  }, [token]);

  const handleonVerify = token => {
    console.log("captcha verified");
    setToken(token);
  };

  const handleSubmit = event => {
    setRadioval($("input[name=enquirytype]:checked").val())
    $("input[name=enquirytype]").val(radioval)
    const form = event.currentTarget;

    if (form.checkValidity() === false) {
      event.preventDefault();
      event.stopPropagation();
      setShowerror(true);
      setValidated(true);
      setThankyou(false);
      myRef.current.scrollIntoView({ behavior: 'smooth', block: 'center' })
    }
    else {
     $('.instant-val-form .step-4').hide();
     $('.instant-val-form .step-2').hide();
     $('.valpal-list-api').show();
     $('.val-heading').hide();
      event.preventDefault();

      const formsdata = (event.target);
      const json = {}
      Object.keys(formsdata).map(key => (
        json[formsdata[key].name] = (formsdata[key].checked) ? radioval : formsdata[key].value
      ))

      json['email_temp_user'] = fields[0].email_temp_user;
      json['email_temp_admin'] = fields[0].email_temp_admin;
      json['formname'] = fields[0].formname;
      json['g-recaptcha-response'] = token;
      json['extra'] = _.omit(json, ["formname", "name", "email", "telephone"])

      if(json['addressPostalCode'] && props.postcode_mapping){
       let post = json['addressPostalCode'].split(' ')[0];
        props.postcode_mapping.map((list, key) => { 
          if (list.codes.includes(post.trim().toUpperCase())) {
            switch (json['enquirytype']) {
              case "sale":
                json['to_email_id'] = list.email.sale;
                break;
              case "let":
                json['to_email_id'] = list.email.rental;
                break; 
              default:
                json['to_email_id'] = list.email.default;
            } 
          } 
        })
      }
    
      setFormvalues(json);

      recaptchaRef.current.execute();

      setValidated(false);

      // reset form
      const form = event.target
      form.reset();
      setStartDate();
      setStartTime();
    }
  };

  return (
    <div className="form stbform common_form_class" id="contactform">
    <div ref={myRef} />

    {showerror && <div className="alert-error">
      <p>{fields[0].error_text}</p>
    </div>}

    {showthankyou && <div className="alert-success d-none">
      <p>{fields[0].success_text}</p>
    </div>}

    
      <Form className="book-a-valueform contact-form form-w-label instant-val-form" name={fields[0].formname} action="/thank-you/" method="post" noValidate validated={validated} onSubmit={handleSubmit}>
        <div className="steps-error"></div>
        <input type="hidden" name="form_name" value={fields[0].formname} />
        <input type="hidden" name="form_type" value={fields[0].form_type} />
        <input type="hidden" name="to_email_id" value={props.to_email_id} />
        <input type="hidden" name="bot-field" />
        <input type="hidden" name="sales_min_val" id="sales_min_val" value=""/>
        <input type="hidden" name="sales_avg_val" id="sales_avg_val" value=""/>
        <input type="hidden" name="sales_max_val" id="sales_max_val" value=""/>
        <input type="hidden" name="rental_min_val" id="rental_min_val" value=""/>
        <input type="hidden" name="rental_avg_val" id="rental_avg_val" value=""/>
        <input type="hidden" name="rental_max_val" id="rental_max_val" value=""/>


        <div className="form-wrapper step-1">
        {fields.map((field, index) => {           
            if ("radio" === field.element) {
              return (
                <RadioField
                  name={field.name}
                  ref={field.ref}
                  value={field.value}
                  fieldClass={field.class}
                  checked={field.checked}
                  placeholder={field.placeholder}
                  required={field.required}
                  key={`${field.name}~${index}`}
                  handlechange={getRadio}
                  lastchild={field.lastchild}
                  type={field.type}
                />
              );
            }
            
          })
        }
        </div>
        <InstantValuationSteps showthankyou={showthankyou}/>

        {fields.map((field, index) => {

            if ("captcha" === field.element) {
              return (
                <ReCaptchaBox
                  fieldClass={field.class}
                  captRef={field.captchaRef}
                  key={`${field.element}~${index}`}
                  handleonVerify={handleonVerify}
                />
              );
            }
            // if ("button" === field.element) {
            //   return (
            //     <ButtonField
            //       name={field.name}
            //       fieldClass={field.class}
            //       type={field.type}
            //       value={field.value}
            //       key={`${field.element}~${index}`}
            //     />
            //   );
            // }
          })
        }

      </Form>
    </div>
  );
}


const ContactForm = (props) => (
  <MySimpleForm to_email_id={props.to_email_id} postcode_mapping={props.postcode_mapping} />
)

export default ContactForm